export default {
  data() {
    return {
      showPlanLimitModal: false,
    };
  },
  methods: {
    handlePlanLimitError(error) {
      if (error?.response?.status === 402) {
        this.showPlanLimitModal = true;
        return true;
      }
      return false;
    },
  },
};
